import { render, staticRenderFns } from "./storeAcceptedvisits.vue?vue&type=template&id=bf5b479e&scoped=true"
import script from "./storeAcceptedvisits.vue?vue&type=script&lang=js"
export * from "./storeAcceptedvisits.vue?vue&type=script&lang=js"
import style0 from "./storeAcceptedvisits.vue?vue&type=style&index=0&id=bf5b479e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5b479e",
  null
  
)

export default component.exports